import React, { useEffect, useRef } from 'react';

import { useRippleEffect } from '../../hooks/useRippleEffect';
import styles from './PrimaryButton.module.less';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}

const WAVE_DURATION = 2000;
const INITIAL_RIPPLE_DELAY = 500;

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  fullWidth = false,
  className,
  disabled,
  onClick,
  ...props
}) => {
  const { ripples, createRipple } = useRippleEffect<'button'>(WAVE_DURATION);
  const hasTriggeredInitialRipple = useRef(false);

  useEffect(() => {
    if (!hasTriggeredInitialRipple.current) {
      hasTriggeredInitialRipple.current = true;
      const timer = setTimeout(() => {
        createRipple('button');
      }, INITIAL_RIPPLE_DELAY);
      return () => clearTimeout(timer);
    }
  }, [createRipple]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    createRipple('button');
    onClick?.(e);
  };

  return (
    <button
      className={`${styles.button} ${styles.primary} ${fullWidth ? styles.fullWidth : ''} ${disabled ? styles.disabled : ''} ${className ?? ''}`}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      <span className={styles.buttonText}>{children}</span>
      {ripples.map(ripple => (
        <span key={ripple.id} className={styles.wave} />
      ))}
    </button>
  );
};
